function slugify(str) {
  return String(str)
    .normalize("NFKD") // split accented characters into their base characters and diacritical marks
    .replace(/[\u0300-\u036f]/g, "") // remove all the accents, which happen to be all in the \u03xx UNICODE block.
    .trim() // trim leading or trailing whitespace
    .toLowerCase() // convert to lowercase
    .replace(/[^a-z0-9 -]/g, "") // remove non-alphanumeric characters
    .replace(/\s+/g, "-") // replace spaces with hyphens
    .replace(/-+/g, "-"); // remove consecutive hyphens
}

export const nifty50 = [
  { name: "Power Grid Corporation of India Ltd." },
  { name: "Larsen & Toubro Ltd." },
  { name: "Mahindra & Mahindra Ltd." },
  { name: "Cipla Ltd." },
  { name: "Bharat Petroleum Corporation Ltd." },
  { name: "Tata Consumer Products Ltd." },
  { name: "HDFC Bank Ltd." },
  { name: "Sun Pharmaceutical Industries Ltd." },
  { name: "Maruti Suzuki India Ltd." },
  { name: "Apollo Hospitals Enterprise Ltd." },
  { name: "Coal India Ltd." },
  { name: "Axis Bank Ltd." },
  { name: "Hero MotoCorp Ltd." },
  { name: "Kotak Mahindra Bank Ltd." },
  { name: "Tata Steel Ltd." },
  { name: "IndusInd Bank Ltd." },
  { name: "UltraTech Cement Ltd." },
  { name: "State Bank of India" },
  { name: "Grasim Industries Ltd." },
  { name: "NTPC Ltd." },
  { name: "Bajaj Auto Ltd." },
  { name: "Bajaj Finance Ltd." },
  { name: "UPL Ltd." },
  { name: "Oil And Natural Gas Corporation Ltd." },
  { name: "Eicher Motors Ltd." },
  { name: "Adani Ports & Special Economic Zone Ltd." },
  { name: "LTIMindtree Ltd." },
  { name: "ICICI Bank Ltd." },
  { name: "Asian Paints Ltd." },
  { name: "JSW Steel Ltd." },
  { name: "Dr. Reddy's Laboratories Ltd." },
  { name: "Divi's Laboratories Ltd." },
  { name: "HDFC Life Insurance Company Ltd." },
  { name: "Tata Consultancy Services Ltd." },
  { name: "Bajaj Finserv Ltd." },
  { name: "Hindustan Unilever Ltd." },
  { name: "Infosys Ltd." },
  { name: "Britannia Industries Ltd." },
  { name: "Bharti Airtel Ltd." },
  { name: "SBI Life Insurance Company Ltd." },
  { name: "Tech Mahindra Ltd." },
  { name: "Wipro Ltd." },
  { name: "ITC Ltd." },
  { name: "Tata Motors Ltd." },
  { name: "Titan Company Ltd." },
  { name: "HCL Technologies Ltd." },
  { name: "Nestle India Ltd." },
  { name: "Hindalco Industries Ltd." },
  { name: "Adani Enterprises Ltd." },
  { name: "Reliance Industries Ltd." },
  { name: "Jio Financial Services Ltd." },
].map(item => ({
  ...item,
  slug: `${slugify(item.name)}-share`,
}));
